const CaseStatus = {
    CaseCreatedWithoutFiles: {id: 1, title: "არ არის შევსებული", titleForInternalUser: "არ არის შევსებული"},
    CaseCreatedWithFiles: {id: 2, title: "განხილვის პროცესშია", titleForInternalUser: "განხილვის პროცესშია"},
    Approved: {
        id: 3,
        title: "დასრულებულია - დადებითი პასუხი",
        titleForInternalUser: "დასრულებულია - დადებითი პასუხი",
        forInternalUser: true,
        color: "green"
    },
    Declined: {id: 4, title: "დახარვეზებულია", titleForInternalUser: "დახარვეზებულია"},
    waitingForVisage: {id: 5, title: "განხილვის პროცესშია", titleForInternalUser: "ელოდება ვიზას"},
    Canceled: {id: 6, title: "ძალადაკარგულად გამოცხადდა", titleForInternalUser: "ძალადაკარგულად გამოცხადდა"},
    UnderReview: {id: 7, title: "განხილვის პროცესშია", titleForInternalUser: "განხილვის პროცესშია"},
    FinishedDenied: {
        id: 8,
        title: "დასრულებულია - უარი ნებართვაზე",
        titleForInternalUser: "დასრულებულია - უარი ნებართვაზე",
        forInternalUser: true,
        color: "red"
    },
    Invalid: {id: 9, title: "გამოცხადდა ძალადაკარგულად", titleForInternalUser: "გამოცხადდა ძალადაკარგულად"},
    ConditionalEnded: {
        id: 10,
        title: "დასრულებულია პირობით",
        titleForInternalUser: "დასრულებულია პირობით",
        forInternalUser: false,
        color: "#d1ac28"
    },
    WaitingForVisageCond: {id: 11, title: "განხილვის პროცესშია", titleForInternalUser: "პირობითი ელოდება ვიზას"},
    Exploitation: {
        id: 12,
        title: "მოთხოვნა ექსპლოატაციაში მიღებაზე",
        titleForInternalUser: "მოთხოვნა ექსპლოატაციაში მიღებაზე"
    },
    UserIsAbleToAddFiles: {id: 13, title: "განხილვის პროცესშია", titleForInternalUser: "განხილვის პროცესშია"},
    Unexamined: {id: 14, title: "განუხილველი", titleForInternalUser: "განუხილველი"},
    Postponed: {id: 15, title: "ვადაგარძელებული", titleForInternalUser: "ვადაგარძელებული"},
    Overdue: {id: 16, title: "განხილვის პროცესშია", titleForInternalUser: "ვადაგადაცილებული"},
    Sent: {id: 17, title: "გაგზავნილია", titleForInternalUser: "გაგზავნილია"},
    expertCase: {id: 18, title: "შიდა განაცხადი", titleForInternalUser: "შიდა განაცხადი"},
};

export default CaseStatus;

export function findStatusTitleById(statusId, isObjectRegistery = false) {

    if (statusId === 8 && isObjectRegistery) {
        return "დასრულებული - უარი რეგისტრაციაზე";
    }

    for (const key in CaseStatus) {
        if (CaseStatus.hasOwnProperty(key)) {
            const status = CaseStatus[key];
            if (status.id === statusId) {
                return status.title;
            }
        }
    }
    return "";
}

export function findStatusTitleByIdForInternalUser(statusId, isObjectRegistery) {

    if (statusId === 8 && isObjectRegistery) {
        return "დასრულებული - უარი რეგისტრაციაზე";
    }


    for (const key in CaseStatus) {
        if (CaseStatus.hasOwnProperty(key)) {
            const status = CaseStatus[key];
            if (status.id === statusId) {
                return status.titleForInternalUser;
            }
        }
    }
    return "";
}

export function findMatchingStatusesById(statusIds) {
    const titles = statusIds.map(id => CaseStatus[Object.keys(CaseStatus).find(key => CaseStatus[key].id === id)].title);
    const matchingStatuses = Object.values(CaseStatus).filter(status => titles.includes(status.title));
    return Array.from(new Set(matchingStatuses.map(status => status.id)));
}

export function findMatchingInternalStatusesById(statusIds) {
    const titles = statusIds.map(id => CaseStatus[Object.keys(CaseStatus).find(key => CaseStatus[key].id === id)].titleForInternalUser);
    const matchingStatuses = Object.values(CaseStatus).filter(status => titles.includes(status.titleForInternalUser));
    return Array.from(new Set(matchingStatuses.map(status => status.id)));
}
